var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.contracts),function(contract){return [_c('contract-list-tile',{key:contract.id,attrs:{"contract":contract}}),_c('v-divider',{key:'divider-' + contract.id})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }